import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const shiftApi = createApi({
  reducerPath: "shiftApi",
  baseQuery: appBaseQuery,
  tagTypes: ["Shift"],
  endpoints: (builder) => ({
    getShifts: builder.query({
      query: (params = {}) => buildPagedListUrl("shift/", params),
      providesTags: ["Shift"],
    }),
    addShift: builder.mutation({
      query: (newShift) => ({
        url: "shift/",
        method: "POST",
        body: newShift,
      }),
      invalidatesTags: ["Shift"],
    }),
    updateShift: builder.mutation({
      query: ({ uid, ...updatedShift }) => ({
        url: `shift/${uid}`,
        method: "PUT",
        body: updatedShift,
      }),
      invalidatesTags: ["Shift"],
    }),
    deleteShift: builder.mutation({
      query: (uid) => ({
        url: `shift/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Shift"],
    }),
  }),
});

export const {
  useGetShiftsQuery,
  useAddShiftMutation,
  useUpdateShiftMutation,
  useDeleteShiftMutation,
} = shiftApi;
